import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import NutrientsService from "../services/nutrientsService";

// Add Nutrient Start
const defaultNutrientState = {
  addNutrientLoading: false,
  addNutrientData: null,
  addNutrientError: null,
};

const addNutrientData = createAsyncThunk(
  "nutrients/add",
  async (payload) => {
    return await NutrientsService.createNutrient(payload);
  },
);

const addNutrientReducer = createSlice({
  name: "addNutrientData",
  initialState: defaultNutrientState,
  extraReducers: (builder) => {
    builder.addCase(addNutrientData.pending, (state) => {
      state.addNutrientLoading = true;
    });
    builder.addCase(addNutrientData.fulfilled, (state, action) => {
      state.addNutrientLoading = false;
      state.addNutrientData = action.payload;
      state.addNutrientError = "";
    });
    builder.addCase(addNutrientData.rejected, (state, action) => {
      state.addNutrientLoading = false;
      state.addNutrientData = null;
      state.addNutrientError = action.error.message;
    });
  },
});

export const AddNutrientReducer = addNutrientReducer.reducer;
export const AddNutrientData = addNutrientData;
// Add Nutrient End

// Update Nutrient Start
const updateNutrientState = {
  updateNutrientLoading: false,
  updateNutrientData: null,
  updateNutrientError: null,
};

const updateNutrient = createAsyncThunk(
  "nutrients/update",
  async (payload) => {
    return await NutrientsService.updateNutrient(payload);
  },
);

const updateNutrientReducer = createSlice({
  name: "updateNutrientReducer",
  initialState: updateNutrientState,
  extraReducers: (builder) => {
    builder.addCase(updateNutrient.pending, (state) => {
      state.updateNutrientLoading = true;
    });
    builder.addCase(updateNutrient.fulfilled, (state, action) => {
      state.updateNutrientLoading = false;
      state.updateNutrientData = action.payload;
      state.updateNutrientError = "";
    });
    builder.addCase(updateNutrient.rejected, (state, action) => {
      state.updateNutrientLoading = false;
      state.updateNutrientData = null;
      state.updateNutrientError = action.error.message;
    });
  },
});

export const UpdateNutrientReducer = updateNutrientReducer.reducer;
export const UpdateNutrient = updateNutrient;
//Update Nutrient End

// Get Nutrients Data List Start
const defaultNutrientListData = {
  getNutrientsListLoading: false,
  getNutrientsListData: null,
  getNutrientsListError: null,
};

const defaultNutrientsReq = {
  sort_by: "name",
  sort_order: "ASC",
  is_active: true,
  limit: 100,
};

const fetchNutrientsList = createAsyncThunk(
  "nutrients/nutrientsList",
  async (payload = defaultNutrientsReq) => {
    return await NutrientsService.getNutrientsList(payload || defaultNutrientsReq);
  },
);

const getNutrientsListReducer = createSlice({
  name: "getNutrientsListData",
  initialState: defaultNutrientListData,
  extraReducers: (builder) => {
    builder.addCase(fetchNutrientsList.pending, (state) => {
      state.getNutrientsListLoading = true;
    });
    builder.addCase(fetchNutrientsList.fulfilled, (state, action) => {
      state.getNutrientsListLoading = false;
      state.getNutrientsListData = action.payload;
      state.getNutrientsListError = "";
    });
    builder.addCase(fetchNutrientsList.rejected, (state, action) => {
      state.getNutrientsListLoading = false;
      state.getNutrientsListData = null;
      state.getNutrientsListError = action.error.message;
    });
  },
});

export const GetNutrientsListReducer = getNutrientsListReducer.reducer;
export const FetchNutrientsList = fetchNutrientsList;
// Get Nutrients Data List End


// Delete Nutrient Start
const defaultDeleteNutrientState = {
  deleteNutrientLoading: false,
  deleteNutrientData: null,
  deleteNutrientError: null,
};

const deleteNutrientData = createAsyncThunk(
  "nutrients/delete",
  async (nutrientID) => {
    return await NutrientsService.deleteNutrient(nutrientID);
  },
);

const deleteNutrientReducer = createSlice({
  name: "deleteNutrientData",
  initialState: defaultDeleteNutrientState,
  extraReducers: (builder) => {
    builder.addCase(deleteNutrientData.pending, (state) => {
      state.deleteNutrientLoading = true;
    });
    builder.addCase(deleteNutrientData.fulfilled, (state, action) => {
      state.deleteNutrientLoading = false;
      state.deleteNutrientData = action.payload;
      state.deleteNutrientError = "";
    });
    builder.addCase(deleteNutrientData.rejected, (state, action) => {
      state.deleteNutrientLoading = false;
      state.deleteNutrientData = null;
      state.deleteNutrientError = action.error.message;
    });
  },
});

export const DeleteNutrientReducer = deleteNutrientReducer.reducer;
export const DeleteNutrientData = deleteNutrientData;
// Delete Nutrient End
